
<div class="modal-body">
  <div class="row">
    <h2 class="modal-title">{{ 'brapi-sync.trial.heading' | translate }}</h2>
  </div>
  <div class="row">
    <div class="col-10">
      <app-study-selector (onSelect)="onStudySelect()"></app-study-selector>
    </div>
  </div>
  @if (context.sourceStudy?.studyDbId) {
    <div class="row">
      <div class="col">
        <app-collapsible [heading]="'brapi-sync.trial.connection-info' | translate">
          <div class="card">
            <div class="card-body">
              <h5><span class="badge badge-pill text-bg-success text-white">{{context.sourceStudy.studyName}}</span></h5>
            </div>
          </div>
        </app-collapsible>
        <app-collapsible heading="{{context.sourceTrial.trialName + ' Metadata'}}">
          <div class="table-responsive">
            <table class="table table-bordered table-striped table-curved">
              <thead class="thead-light">
                <tr>
                  <th scope="col">{{ 'brapi-sync.trial.table.key' | translate }}</th>
                  <th scope="col">{{ 'brapi-sync.trial.table.value' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td ><span class="fw-bold">{{ 'brapi-sync.trial.table.trial-description' | translate }}</span></td>
                  <td>{{context.sourceTrial.trialDescription}}</td>
                </tr>
                <tr>
                  <td ><span class="fw-bold">{{ 'brapi-sync.trial.table.start-date' | translate }}</span></td>
                  <td>{{context.sourceTrial.startDate}}</td>
                </tr>
                <tr>
                  <td ><span class="fw-bold">{{ 'brapi-sync.trial.table.end-date' | translate }}</span></td>
                  <td>{{context.sourceTrial.endDate}}</td>
                </tr>
                <tr>
                  <td ><span class="fw-bold">{{ 'brapi-sync.trial.table.documentation-url' | translate }}</span></td>
                  <td>{{context.sourceTrial.documentationUrl}}</td>
                </tr>
                <tr>
                  <td ><span class="fw-bold">{{ 'brapi-sync.trial.table.publications' | translate }}</span></td>
                  <td>
                    @if (context.sourceTrial?.publications?.length) {
                      <app-expandable-json-viewer [json]="context.sourceTrial?.publications"></app-expandable-json-viewer>
                    }
                  </td>
                </tr>
                <tr>
                  <td ><span class="fw-bold">{{ 'brapi-sync.trial.table.contacts' | translate }}</span></td>
                  <td>
                    @if (context.sourceTrial?.contacts?.length) {
                      <app-expandable-json-viewer [json]="context.sourceTrial?.contacts"></app-expandable-json-viewer>
                    }
                  </td>
                </tr>
                <tr>
                  <td ><span class="fw-bold">{{ 'brapi-sync.trial.table.additional-info' | translate }}</span></td>
                  <td>
                    @if (context.sourceTrial?.additionalInfo) {
                      <app-expandable-json-viewer [json]="context.sourceTrial?.additionalInfo"></app-expandable-json-viewer>
                    }
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </app-collapsible>
      </div>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="cancel()">{{ 'cancel' | translate }}</button>
  <button type="button" class="btn btn-primary ms-2" (click)="post()" [disabled]="!isValid()">
    @if (loading) {
      <span class="throbber throbber-btn"></span>
    }
    {{ 'brapi-sync.buttons.import-trial-metadata' | translate }}
  </button>
  <button type="button" class="btn btn-info ms-2" (click)="next()" [disabled]="!canProceed()">
    {{ 'next' | translate }}
  </button>
</div>

